"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SortingTable;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireDefault(require("react"));
var _ = require("../..");
function SortingTable(_ref) {
  var classes = _ref.classes,
    className = _ref.className,
    id = _ref.id,
    input = _ref.input,
    fields = _ref.fields,
    options = _ref.options;
  function _moveListItem(dragIndex, hoverIndex, items) {
    var dragitem = items[dragIndex];
    var dragList = [].concat((0, _toConsumableArray2.default)(items.slice(0, dragIndex)), (0, _toConsumableArray2.default)(items.slice(dragIndex + 1, items.length)));
    var hoverList = [].concat((0, _toConsumableArray2.default)(dragList.slice(0, hoverIndex)), [dragitem], (0, _toConsumableArray2.default)(dragList.slice(hoverIndex, dragList.length)));
    input.onChange(hoverList.map(function (val) {
      return val.value;
    }));
  }
  return input.value && /*#__PURE__*/_react.default.createElement(_.Table, {
    classes: classes,
    className: className,
    fields: fields,
    id: id,
    items: input.value ? input.value.map(function (value) {
      var option = options.find(function (opt) {
        return opt.value === value;
      });
      return (0, _extends2.default)({}, option, {
        id: value,
        name: option == null ? void 0 : option.label
      });
    }) : [],
    moveListItem: function moveListItem() {
      return _moveListItem.apply(void 0, arguments);
    },
    reorderable: true,
    sorting: false
  });
}